import { Card } from '@optools/components/ui/card';
import { CopyrightStream as CopyrightStreamType } from '@optools/services/operator-gateway/types/generated/graphql';

import { CopyrightStreamActions } from './copyright-stream-actions';
import { CopyrightStreamStatusBadge } from './copyright-stream-status-badge';
import { CopyrightStreamStatus } from './types';

export interface CopyrightStreamItemProps {
  stream: CopyrightStreamType;
}

export function CopyrightStreamItem({ stream }: CopyrightStreamItemProps) {
  const { feedType, id, status, streamEndTime, streamStartTime } = stream;
  const streamStatus = status as CopyrightStreamStatus;

  return (
    <Card
      className="flex animate-fade-in flex-wrap items-center justify-between gap-8 p-4"
      data-testid={`copyright-stream-${id}`}>
      <dl className="flex items-start gap-8">
        <div>
          <dt className="mb-2 font-bold" id="id">
            ID
          </dt>
          <dd aria-labelledby="id" className="text-sm">
            {id}
          </dd>
        </div>

        <div>
          <dt className="mb-2 font-bold" id="status">
            Status
          </dt>
          <dd aria-labelledby="status" className="text-sm">
            <CopyrightStreamStatusBadge status={streamStatus} />
          </dd>
        </div>

        <div>
          <dt className="mb-2 font-bold" id="feed-type">
            Feed Type
          </dt>
          <dd aria-labelledby="feed-type" className="text-sm">
            {feedType}
          </dd>
        </div>

        <div>
          <dt className="mb-2 font-bold" id="stream-start-time">
            Stream Start Time
          </dt>
          <dd aria-labelledby="stream-start-time" className="text-sm">
            {streamStartTime ?? '--'}
          </dd>
        </div>

        <div>
          <dt className="mb-2 font-bold" id="stream-end-time">
            Stream End Time
          </dt>
          <dd aria-labelledby="stream-end-time" className="text-sm">
            {streamEndTime ?? '--'}
          </dd>
        </div>
      </dl>

      <CopyrightStreamActions status={streamStatus} streamId={id} />
    </Card>
  );
}
